import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { H2 } from "commons";
import { IN_PROGRESS, isSuccess } from "commons/src/helpers/RequestHelpers";

import { BankAccount } from "./BankAccount";
import { Message } from "../../components/Message";
import { ERROR, getRefetchMessageAndAction } from "../../helpers/ErrorHelpers";
import { retryFetch } from "../../components/DataOperations";
import { setBankAccountDetails } from "../../reducers/bankAccountsActions";
import { requestObject } from "../../reducers/requestsActions";

export function BankAccounts({ bankAccounts, requestStatus }) {
    const makeBankAccount = acct => {
        return (
            <BankAccount
                key={acct.bankAccountId}
                clientRef={acct.clientId}
                accountNumber={acct.accountNumber}
                accountName={acct.accountName}
                sortCode={acct.sortCode}
            />
        );
    };

    const mapBankAccounts = accts => {
        const mappedBankAccounts = accts
            .filter(acct => acct.bankAccountStatus === "Active")
            .map(acct => makeBankAccount(acct));
        return mappedBankAccounts.length > 0 ? (
            mappedBankAccounts
        ) : (
            <span>Bank account to be set up</span>
        );
    };

    const refetch = () => {
        retryFetch(requestStatus.href, setBankAccountDetails, "bankAccounts");
    };

    const { message, action } = getRefetchMessageAndAction(requestStatus, refetch);

    return (
        <div>
            <H2 secondary textAlign="center">
                Bank account(s)
            </H2>
            <Details>
                <Message
                    severity={ERROR}
                    text={message}
                    errorCode={requestStatus.errorCode}
                    shown={!!message}
                    padding="0px"
                    action={action}
                />
                {isSuccess(requestStatus.status) && mapBankAccounts(bankAccounts.accounts)}
                <ClearBoth />
            </Details>
        </div>
    );
}

const ClearBoth = styled.div`
    clear: both;
`;

const Details = styled.div`
    background: ${props => props.theme.tertiary};
    padding: 1.5em;
    height: auto;
`;

BankAccounts.defaultProps = {
    bankAccounts: {
        accounts: []
    },
    requestStatus: {
        status: IN_PROGRESS
    }
};

BankAccounts.propTypes = {
    bankAccounts: PropTypes.shape({
        accounts: PropTypes.array
    }),
    requestStatus: requestObject
};
